import { useEffect, useState } from 'react';

interface IpInfo {
  ip: string;
  country?: string;
  country_code?: string;
}

function getFlagEmoji(countryCode: string) {
  if (!countryCode) return '';
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

export function Footer() {
  const [ipInfo, setIpInfo] = useState<IpInfo | null>(null);
  const [now, setNow] = useState<Date>(new Date());

  useEffect(() => {
    // Update time every minute
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    let aborted = false;
    async function fetchIp() {
      try {
        // Primary: ipapi.co
        const res = await fetch('https://ipapi.co/json/');
        if (!res.ok) throw new Error('ipapi.co failed');
        const data = await res.json();
        if (!aborted) setIpInfo({ ip: data.ip, country: data.country_name, country_code: data.country });
      } catch (e) {
        try {
          // Fallback: ifconfig.co
          const res2 = await fetch('https://ifconfig.co/json');
          if (!res2.ok) throw new Error('ifconfig.co failed');
          const data2 = await res2.json();
          if (!aborted) setIpInfo({ ip: data2.ip, country: data2.country, country_code: data2.country_iso });
        } catch (e2) {
          // Silent fail
          if (!aborted) setIpInfo({ ip: 'Unknown' });
        }
      }
    }
    fetchIp();
    return () => {
      aborted = true;
    };
  }, []);

  const dateText = now.toLocaleDateString(undefined, {
    year: 'numeric', month: 'long', day: 'numeric',
  });

  return (
    <footer className="py-8 px-4 sm:px-6 lg:px-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between text-center gap-3">
        <div className="font-rajdhani text-white/60">
          © {now.getFullYear()} syphfoix. Built with React, Three.js, and AI-powered creativity.
        </div>
        <div className="font-rajdhani text-white/70 flex items-center justify-center gap-3">
          <span className="px-2 py-1 bg-white/10 rounded-full border border-white/20">{ipInfo?.ip ?? '...'}</span>
          {ipInfo?.country_code && (
            <span title={ipInfo.country} className="px-2 py-1 bg-white/10 rounded-full border border-white/20">
              {getFlagEmoji(ipInfo.country_code)} {ipInfo.country_code}
            </span>
          )}
          <span className="px-2 py-1 bg-white/10 rounded-full border border-white/20">{dateText}</span>
        </div>
      </div>
    </footer>
  );
}
